module.exports = __webpack_public_path__ + "img/限时商品8.28cb57e2.png";